/**
 * @file 日本連盟役務マスタメンテナンス画面の更新ボタン
 */

'use strict'


/**
 * @classname BtnUpdateMasterMaintenanceTitle
 * @classdesc 日本連盟役務マスタメンテナンス画面の更新ボタン
 */
export default class BtnUpdateMasterMaintenanceTitle {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('btn-update-master-maintenance-title')
	 */
	constructor($e, controller) {
		console.log(`BtnUpdateMasterMaintenanceTitle.constructor`)
		this._$e = $e
		this._controller = controller
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnUpdateMasterMaintenanceTitle
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnUpdateMasterMaintenanceTitle.onClick`)
		this._controller._listener.trigger('validate')
		if (!$('.is-invalid:not(.ignore-validation)').length) this._controller.updateMasterMaintenanceTitle(this.appendFormData())
	}


	/**
	 * FormDataを作成
	 *
	 * @memberof BtnUpdateMasterMaintenanceTitle
	 * @return {undefined}
	 */
	appendFormData() {
		console.log(`BtnUpdateMasterMaintenanceTitle.appendFormData`)
		let logData = {}
		const formData = new FormData()
		$('.sortable-list').each((_, element) => {
			const $sortableList = $(element)
			let titles = []
			$sortableList.find('.sortable-list__item').each((index, sortableListItem) => {
				const $sortableListItem = $(sortableListItem)
				const $inputText = $sortableListItem.find('.input-text')
				let title = {}
				title['code'] = $inputText.data('code')
				title[$inputText.attr('name')] = $inputText.val()
				title['display_order_num'] = index + 1
				titles.push(title)
			})
			formData.append($sortableList.data('sortable-list-name'), titles)
			logData[$sortableList.data('sortable-list-name')] = titles
		})
		console.log(logData)
		return formData
	}
}
